import { populate } from "populate";

const raw = {
  width: 1351,
  height: 760,
  x: 50,
  y: 50,
  list: [
    {
      id: "91e66768-b486-44d1-b965-eb69d19ed7c4",
      type: "Container",
      name: "root",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "",
      data: ""
    },
    {
      id: "e603af46-2ca9-4b18-9fd5-710d00083f05",
      type: "Graphics",
      name: "overlay",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "91e66768-b486-44d1-b965-eb69d19ed7c4",
      bake: false,
      commands: [
        {
          id: "7a41f602-a066-40b1-b1c3-086211926716",
          type: "beginFill",
          color: 0,
          alpha: 0.8
        },
        {
          id: "8fa7f620-037c-4b45-98bb-a95742b0b24f",
          type: "drawRect",
          x: -2000,
          y: -2000,
          width: 4000,
          height: 4000
        }
      ],
      data: ""
    },
    {
      id: "653a8bb2-86ed-4dd8-acc8-9ad013be002c",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -355,
      y: -179,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "combo_tutorial_mixed_1",
      parent: "91e66768-b486-44d1-b965-eb69d19ed7c4",
      data: ""
    },
    {
      id: "7fc0e5a8-3caa-4aef-9f99-72d4066626f9",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -355,
      y: 65,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "combo_tutorial_onecolor_1",
      parent: "91e66768-b486-44d1-b965-eb69d19ed7c4",
      data: ""
    },
    {
      id: "c5580b67-9d0a-4d91-8439-53930d557e89",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -4,
      y: -177,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "combo_tutorial_mixed_2",
      parent: "91e66768-b486-44d1-b965-eb69d19ed7c4",
      data: ""
    },
    {
      id: "6be6f9ab-f880-4ef3-9077-c10498dde850",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -4,
      y: 65,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "combo_tutorial_onecolor_2",
      parent: "91e66768-b486-44d1-b965-eb69d19ed7c4",
      data: ""
    },
    {
      id: "4bf01ea4-e795-4e65-ac3c-16f2d75cd1a3",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 419,
      y: -160,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "combo_tutorial_mixed_3",
      parent: "91e66768-b486-44d1-b965-eb69d19ed7c4",
      data: ""
    },
    {
      id: "725f6bc3-cf5f-4254-b7b2-5f4f5ae0494b",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 417,
      y: 81,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "combo_tutorial_onecolor_3",
      parent: "91e66768-b486-44d1-b965-eb69d19ed7c4",
      data: ""
    },
    {
      id: "426d9dcc-f63b-419e-a4c8-5a63e612cd01",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -212,
      y: -174,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "combo_tutorial_arrow",
      parent: "91e66768-b486-44d1-b965-eb69d19ed7c4",
      data: ""
    },
    {
      id: "fefc3a00-059f-4eb3-a1f3-5480077d3884",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -212,
      y: 64,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "combo_tutorial_arrow",
      parent: "91e66768-b486-44d1-b965-eb69d19ed7c4",
      data: ""
    },
    {
      id: "2b20f5d5-151f-4f4e-948c-8f113d0b5f7a",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 207,
      y: -174,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "combo_tutorial_arrow",
      parent: "91e66768-b486-44d1-b965-eb69d19ed7c4",
      data: ""
    },
    {
      id: "0d69a433-08af-4cc1-a491-b2bb499f736d",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 207,
      y: 64,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "combo_tutorial_arrow",
      parent: "91e66768-b486-44d1-b965-eb69d19ed7c4",
      data: ""
    },
    {
      id: "2986e220-ffcb-49dc-864c-e077410c10dc",
      type: "Text",
      name: "",
      nameSpace: "",
      className: "",
      x: -96,
      y: -127,
      anchor: {
        x: 0.5,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "StreakTutorialA",
      localize: true,
      maxWidth: 688,
      maxHeight: 114,
      maxFontSize: 36,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#fbfa54",
        stroke: "black",
        strokeThickness: 0,
        align: "center",
        wordWrap: true,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "91e66768-b486-44d1-b965-eb69d19ed7c4",
      data: ""
    },
    {
      id: "beb2ce19-5110-4366-89b8-6a31e82b3779",
      type: "Text",
      name: "",
      nameSpace: "",
      className: "",
      x: -96,
      y: 116,
      anchor: {
        x: 0.5,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "StreakTutorialB",
      localize: true,
      maxWidth: 688,
      maxHeight: 114,
      maxFontSize: 36,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#fbfa54",
        stroke: "black",
        strokeThickness: 0,
        align: "center",
        wordWrap: true,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "91e66768-b486-44d1-b965-eb69d19ed7c4",
      data: ""
    },
    {
      id: "92fd29bb-63f6-432f-bafe-849df1f55784",
      type: "Sprite",
      name: "playContainer",
      nameSpace: "",
      className: "",
      x: 0,
      y: 293,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blank",
      parent: "91e66768-b486-44d1-b965-eb69d19ed7c4",
      data: ""
    },
    {
      id: "fc6dc6ca-180d-4309-9de2-8bca03a43ebe",
      type: "Sprite",
      name: "playButton",
      nameSpace: "",
      className: "",
      x: 0,
      y: 5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: "None"
      },
      texture: "button_medium_blue",
      parent: "92fd29bb-63f6-432f-bafe-849df1f55784",
      data: ""
    },
    {
      id: "e6fe52ec-468d-42bb-b768-1052fa8f36f0",
      type: "Text",
      name: "playText",
      nameSpace: "",
      className: "",
      x: 0,
      y: -6,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "Continue",
      localize: true,
      maxWidth: 226,
      maxHeight: 71,
      maxFontSize: 48,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ffffff",
        stroke: "#1253a2",
        strokeThickness: 6,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "fc6dc6ca-180d-4309-9de2-8bca03a43ebe",
      data: ""
    }
  ]
} as const;

export class StreakTutorialLayout {
  static raw = raw;
  root: GameObject<PIXI.Container>;
  overlay: GameObject<PIXI.Graphics>;
  playContainer: GameObject<PIXI.Sprite>;
  playButton: GameObject<PIXI.Sprite>;
  playText: GameObject<PIXI.Text>;

  constructor() {
    populate(this, raw);
  }
}
